import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable, Inject, LOCALE_ID } from '@angular/core';

@Injectable()
export class MatPaginatorIntlIta extends MatPaginatorIntl
{
	itemsPerPageLabel = 'Items per page';
	nextPageLabel = 'Next page';
	previousPageLabel = 'Previous page';
	lastPageLabel = 'Last page';
	firstPageLabel = "First page";

	constructor
		(
			@Inject(LOCALE_ID) public locale: string
		)
	{
		super();

		// load localized
		this.loadLocalized();
	}

	// load localized
	loadLocalized()
	{
		switch (this.locale)
		{
			case 'it':
				{
					this.itemsPerPageLabel = 'Risultati per pagina:';
					this.nextPageLabel = 'Avanti';
					this.previousPageLabel = 'Indietro';
					this.lastPageLabel = 'Ultima pagina';
					this.firstPageLabel = "Prima pagina";
				}
		}
	}

	// get range label
	getRangeLabel = function (page, pageSize, length)
	{
		switch (this.locale)
		{
			case 'it':
				if (length === 0 || pageSize === 0)
					return '0 di ' + length;
				break;

			default:
				if (length === 0 || pageSize === 0)
					return '0 of ' + length;
				break;
		}

		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

		switch (this.locale)
		{
			case 'it':
				return startIndex + 1 + ' - ' + endIndex + ' di ' + length;

			default:
				return startIndex + 1 + ' - ' + endIndex + ' of ' + length;
		}
	};
}